{
  "a11y": {
    "home": "Miami To-Do — home",
    "menu": "Menu",
    "closeMenu": "Close menu",
    "search": "Search",
    "language": "Language: {{name}}",
    "mainNav": "Main",
    "categories": "Categories",
    "open": "Open {{title}}",
    "breadcrumb": "Breadcrumb",
    "saved": "Saved",
    "account": "Account",
    "save": "Save {{title}}"
  },
  "nav": {
    "tours": "Tours",
    "boats": "Yachts & Boats",
    "everglades": "Everglades",
    "attractions": "Attractions",
    "dayTrips": "Day Trips",
    "home": "Home"
  },
  "home": {
    "metaTitle": "Things to Do in Miami — Tours, Boat Trips & the Everglades",
    "metaDescription": "Things to do in Miami: Biscayne Bay boat trips, Everglades airboat tours, Art Deco walks in South Beach, Wynwood street art and day trips to Key West.",
    "heroEyebrow": "Your Miami guide",
    "heroTitle": "Make every day extraordinary.",
    "heroLead": "The best tours, boat trips and experiences in Miami — all in one place.",
    "heroAlt": "Downtown Miami skyline over Biscayne Bay, with a yacht and palm trees",
    "featuredTitle": "Featured This Week",
    "featuredEyebrow": "The best of Miami right now",
    "viewAllExperiences": "View all experiences",
    "moodTitle": "Curated for Your Mood",
    "moodEyebrow": "Discover handpicked ideas for any occasion",
    "viewAllCategories": "View all categories",
    "guideTitle": "Things to Do in Miami by Category",
    "guideCount_one": "{{count}} experience",
    "guideCount_other": "{{count}} experiences",
    "guide": {
      "boats": {
        "text": "Biscayne Bay from the water: sightseeing cruises past the skyline and the celebrity homes of Millionaire's Row and Star Island, sunset and champagne cruises, and party boats with drinks. Private captained boats and yachts, most for up to 12 or 13 guests, head for the Haulover sandbar or Raccoon Island to swim; some come with jet skis or a banana boat.",
        "link": "Browse boat tours"
      },
      "everglades": {
        "text": "The wetlands start less than an hour west of the city. Most trips are airboat rides through the sawgrass, looking for alligators and wading birds: an hour on a private or semi-private boat, or a half day with hotel transport, a wildlife show or a walk in Everglades National Park. Some combine the airboat with a Biscayne Bay cruise and a city tour.",
        "link": "Browse Everglades tours"
      },
      "city-tours": {
        "text": "Miami's neighborhoods by golf cart, buggy, Segway, bike, open-top bus or on foot: the murals of Wynwood, the Art Deco hotels and neon of South Beach, the cafés of Little Havana. Three-in-one tours cover all three in half a day; others focus on street art, food, film locations or Coral Gables.",
        "link": "Browse city tours"
      },
      "day-trips": {
        "text": "Full days out of Miami with transport: down the Overseas Highway through Key Largo and Islamorada to Key West, north to the Kennedy Space Center, or to Fort Lauderdale and Palm Beach with the Flagler Museum. Small-group vans and private drivers both run these routes.",
        "link": "Browse day trips"
      },
      "water-sports": {
        "text": "Biscayne Bay is the playground: guided jet ski tours past the skyline and Star Island, yachts that come with jet skis, banana boats and tubing, wakesurfing, waterskiing lessons and jet cars. Many trips start from Miami Beach marinas; check what is included before you book, as fees vary.",
        "link": "Browse water sports"
      },
      "attractions": {
        "text": "Tickets for Miami's museums and sights: Superblue's immersive art, entry to the Wynwood Walls, Pérez Art Museum Miami, Vizcaya Museum and Gardens, the Frost Science museum, Zoo Miami and Jungle Island. City passes bundle several of them into one ticket.",
        "link": "Browse attractions"
      },
      "family": {
        "text": "Days that work for kids and parents alike: Zoo Miami, Jungle Island's animal encounters, the Frost Science museum with its aquarium and planetarium, and the Museum of Ice Cream. An Explorer Pass covers several attractions on one ticket.",
        "link": "Browse family activities"
      }
    }
  },
  "search": {
    "label": "Where in Miami?",
    "placeholder": "Where in Miami?",
    "submit": "Search",
    "landmark": "Search Miami To-Do",
    "searchFor": "Search for “{{query}}”",
    "categories": "Categories",
    "popularTitle": "Popular searches",
    "suggestions": "Suggestions",
    "popular": [
      { "label": "Airboat tour", "q": "airboat" },
      { "label": "Key West", "q": "key west" },
      { "label": "Biscayne Bay cruise", "q": "biscayne" },
      { "label": "South Beach", "q": "south beach" },
      { "label": "Art Deco", "q": "art deco" },
      { "label": "Wynwood Walls", "q": "wynwood" },
      { "label": "Little Havana food tour", "q": "little havana" },
      { "label": "Jet ski", "q": "jet ski" }
    ]
  },
  "mood": {
    "family": "Family Fun"
  },
  "collections": {
    "tours": {
      "seoTitle": "Miami Tours & Excursions: Boats, Everglades, Key West",
      "heading": "Miami Tours & Excursions",
      "intro": "Every tour and experience we list in Miami, best reviewed first.",
      "meta": "Every tour in Miami, ranked by reviews: Biscayne Bay boat tours and yacht charters, Everglades airboat rides, Art Deco and Wynwood tours, Key West day trips.",
      "guideTitle": "How to choose a tour in Miami",
      "guide": [
        {
          "h": "What kinds of tours there are",
          "p": [
            "Most of Miami's tours are on the water. Sightseeing cruises leave Bayside Marketplace downtown for an hour or so on Biscayne Bay, past the mansions of Star Island and Millionaire's Row, the cruise port and the skyline. Private boats with a captain take your own group out for two to four hours — to swim at a sandbar, anchor off a quiet island or watch the sunset over Brickell — and jet ski tours, party boats and fishing charters fill out the rest of the bay.",
            "Inland, the Everglades start less than an hour west of the city: airboat rides skim across the sawgrass looking for alligators and wading birds, from a one-hour ride to a half-day trip with transport and a stop in the national park. In town, walking, golf-cart and Segway tours cover the Art Deco district of South Beach, the murals of Wynwood and the cafés and cigar rollers of Calle Ocho in Little Havana, while helicopter and small-plane flights show Miami Beach from above. Longer day trips run down the Overseas Highway to Key West, or north to Fort Lauderdale, Palm Beach and the Kennedy Space Center."
          ]
        },
        {
          "h": "Planning your days in Miami",
          "p": [
            "Plan around the heat and the weather. Mornings are the calmest time on the water and the coolest for airboats and walking tours; in summer, thunderstorms often build in the afternoon, so book the boat or the Everglades early and keep the late afternoon for a museum or a sunset cruise once the rain has passed. Evenings belong to the skyline: sunset cruises, the neon of Ocean Drive and dinner in Brickell or Wynwood.",
            "Three days cover the classics: a day on Miami Beach with the Art Deco district and a boat trip on the bay, a day for Wynwood and Little Havana, and a morning in the Everglades. Add a long day for Key West — about four hours' drive each way — or a lazy day on the sand. The dry season, from November to April, is the most comfortable and the busiest, with prices and crowds at their peak around Christmas, Art Basel in early December and spring break in March; hurricane season runs from June to November."
          ]
        },
        {
          "h": "Shared, small-group or private?",
          "p": [
            "Shared cruises and bus tours are the cheapest way in, from around $25–30 a person. Small-group tours keep the numbers down — a golf cart in Wynwood, a semi-private airboat, a van to Key West with a dozen travelers — for a more personal guide at a moderate price. Private tours, a large part of this list, cost more but are booked for your party alone: a boat with its captain for up to a dozen guests, an airboat or a car with a guide.",
            "On a private boat the price is usually for the whole group rather than per person, so it pays off when you travel together; check how many guests it takes, whether fuel, drinks and water toys are included, and which marina it leaves from — Miami Beach, Bayside, Haulover or further up the coast. Everglades tours either meet you at the airboat park or include transport from Miami; the listing says which. Tipping the captain or guide is customary in the US, usually 15–20% on private tours, and is often not included in the price."
          ]
        },
        {
          "h": "How this list works",
          "p": [
            "This page lists every tour and experience we have in Miami, ranked by reviews: a tour with hundreds of good reviews comes before one with a perfect score from only a handful of guests. Open a category for a shorter list.",
            "You book on our partner's site, Viator, where you see the live price in US dollars, the available dates and the cancellation policy before you pay. Many experiences can be canceled free of charge up to 24 hours before the start, and most boat and airboat tours offer a new date or a refund if the weather cancels them."
          ]
        }
      ],
      "faq": [
        {
          "q": "What are the best tours in Miami?",
          "a": "The tours travelers rate highest are a private boat trip on Biscayne Bay with a stop at a sandbar, an Everglades airboat ride, the Art Deco walking tour of South Beach, a golf-cart tour of the Wynwood murals and a sunset cruise past Star Island and the skyline. This list puts the tours with the strongest reviews first."
        },
        {
          "q": "How far are the Everglades from Miami?",
          "a": "The airboat parks on the Tamiami Trail and near Homestead are 40 minutes to an hour's drive from Downtown Miami and Miami Beach. The ride itself lasts 30 to 90 minutes; with transport from Miami, plan on four to six hours."
        },
        {
          "q": "Can you do a day trip from Miami to Key West?",
          "a": "Yes, but it is a long day: Key West is about 160 miles away, roughly four hours each way on the Overseas Highway, so tours leave early in the morning and get back late in the evening, with a few hours on the island. Most stop in the Florida Keys on the way."
        },
        {
          "q": "How much does a boat tour in Miami cost?",
          "a": "A shared sightseeing cruise on Biscayne Bay starts at around $25–30 a person. A private boat with a captain starts at about $175–250 for two to four hours, for the whole group; larger yachts with a crew and water toys cost from several hundred to a few thousand dollars. Each card shows the starting price; the partner's site shows the exact price for your date and group."
        },
        {
          "q": "When is the best time to book tours in Miami?",
          "a": "The dry season, from November to April, has the most comfortable weather and the calmest water; it is also the busiest, so book a few days ahead for weekends, the holidays and spring break. From June to November it is hot and humid with afternoon storms: choose morning tours, and check the weather policy before you book a boat."
        },
        {
          "q": "Are tours in Miami available in Spanish or Russian?",
          "a": "Most tours run in English, and many of Miami's guides speak Spanish too — a large share of the tours here are offered in both. Russian-speaking guides are rare. Each tour's languages are listed on its page on the partner's site."
        }
      ]
    },
    "boats": {
      "title": "Yachts & Boats",
      "short": "Boat Tours\n& Cruises",
      "seoTitle": "Miami Boat Tours: Star Island & Millionaire's Row Cruises",
      "heading": "Miami Boat Tours & Bay Cruises",
      "intro": "Biscayne Bay cruises past Millionaire's Row and Star Island, private boat tours with a captain, sunset sails and party boats from Miami.",
      "meta": "Boat tours in Miami: Biscayne Bay sightseeing cruises past Star Island and Millionaire's Row, private boat tours with a captain, sunset and party cruises.",
      "partnerTitle": "Rather have a boat of your own?",
      "partnerText": "The tours above are bookable instantly. For a wider choice of private boats and yachts — by size, marina and number of guests — Sailo lists hundreds of them across Miami, Miami Beach and Key Biscayne.",
      "guideTitle": "How to choose a boat tour in Miami",
      "guide": [
        {
          "h": "Shared cruise or private boat?",
          "p": [
            "The cheapest way onto the water is a shared sightseeing cruise from Bayside Marketplace downtown: about 90 minutes on Biscayne Bay past the cruise port, Fisher Island and the mansions of Star Island and Millionaire's Row, with a guide on the microphone pointing out whose house is whose. Sunset and champagne cruises follow a similar route in the evening, and party boats add music and an open bar.",
            "A private boat with a captain is booked for your group alone, usually for two to six hours and up to 12 or 13 guests. You choose the plan: the skyline and celebrity homes, a swim at a sandbar, lunch on board or the sunset over Brickell. The price is for the whole boat, so for a group of six or more it often costs less per person than you would expect."
          ]
        },
        {
          "h": "Swim stops and water toys",
          "p": [
            "Most private boats stop for a swim on the way: at one of the bay's sandbars, where guests stand waist-deep in clear water, or off Raccoon Island, quieter, with birds and a short walk ashore. For the sandbars themselves — Haulover or Nixon, tides and weekends — see Sandbar Boat Tours.",
            "Many yachts come with jet skis, a banana boat, paddleboards or a floating mat, sometimes included and sometimes at extra cost. Read what the price covers: fuel, the captain, drinks, ice and water toys vary from one boat to the next, and the captain's tip (15–20% is customary) is rarely included."
          ]
        },
        {
          "h": "When to go and what to bring",
          "p": [
            "Mornings usually have the calmest water. In summer, afternoon thunderstorms build quickly, so captains may shorten or move a trip; most tours offer a new date or a refund when the weather cancels them. From November to April the bay is at its best and boats book out at weekends and around the holidays.",
            "Bring reef-safe sunscreen, a hat, a towel and a swimsuit under your clothes, and check the marina — boats leave from Miami Beach, Bayside, the Miami River and Haulover. The list is ranked by reviews, so the boats with the most consistently good ratings come first."
          ]
        }
      ],
      "faq": [
        {
          "q": "How much does a private boat tour in Miami cost?",
          "a": "A small private boat with a captain starts at around $175–250 for two to four hours, for the whole group. Larger yachts of 45–70 feet with a crew and jet skis cost from a few hundred to a few thousand dollars, depending on the size, the length of the trip and the day."
        },
        {
          "q": "Who drives the boat on a private tour?",
          "a": "A licensed captain — every boat in this list comes with one, so you can relax, swim and drink on board. Driving a jet ski yourself is different: see the water sports page."
        },
        {
          "q": "Can we bring our own food and drinks?",
          "a": "On most private charters, yes: you can bring snacks, drinks and a cake for a celebration, often with ice and a cooler provided. Glass bottles are usually not allowed. Shared cruises sell drinks on board instead."
        },
        {
          "q": "Which boat tour shows the celebrity homes?",
          "a": "The shared Millionaire's Row and Star Island cruises from Bayside Marketplace are built around them, with commentary about the owners. Most private boats will also pass Star Island on request."
        }
      ]
    },
    "yacht-rental": {
      "title": "Yacht Rental",
      "short": "Yacht\nRental",
      "intro": "Private yachts with a captain for your group: skyline, Star Island and sandbar charters on Biscayne Bay, many with jet skis on board.",
      "seoTitle": "Yacht Rental in Miami: Private Charters with Captain",
      "heading": "Yacht Rental in Miami",
      "meta": "Rent a private yacht in Miami with a captain: yachts for up to 13 guests on Biscayne Bay, Star Island and sandbar routes, jet ski add-ons and sunset charters.",
      "partnerTitle": "More yachts on Sailo",
      "partnerText": "Sailo lists hundreds of motor yachts for charter around Miami, from 40-foot cruisers to superyachts with a full crew. Filter by size, guests and marina, and book on its site.",
      "guideTitle": "How to rent a yacht in Miami",
      "guide": [
        {
          "h": "What a charter includes",
          "p": [
            "A yacht charter in Miami is a private boat for your group with a licensed captain, usually for three to eight hours. The captain drives, anchors and plans the route with you; larger yachts add a mate who serves drinks and handles the water toys. Fuel for a standard route, ice, water and a cooler are usually included — read the listing, as some charge fuel or a cleaning fee separately.",
            "Jet skis, a floating mat, paddleboards or a banana boat are the common extras, sometimes included and sometimes paid per hour. Food and drinks are mostly BYOB: bring your own (no glass), or ask for catering when you book. The crew's tip is not in the price; 15–20% is customary."
          ]
        },
        {
          "h": "Size, guests and how long",
          "p": [
            "The number of guests decides the boat. Most private yachts in Miami take up to 12 or 13 people — the limit for a boat without a Coast Guard passenger certificate — so a 37–50 ft yacht suits a family or a group of friends, and a 60–70 ft yacht gives the same group more deck, shade and cabins. Larger parties need an inspected party yacht, licensed for dozens of guests.",
            "Charters usually start at three or four hours, with four as the minimum on many yachts at weekends. Four hours is enough for the skyline, Star Island and a swim; six to eight lets you reach a quieter anchorage, have lunch on board and come back at sunset."
          ]
        },
        {
          "h": "Routes and when to go",
          "p": [
            "Classic routes leave Miami Beach, the Miami River or Bayside, pass the cruise port, Fisher Island and the mansions of Star Island and Millionaire's Row, then anchor at the Haulover or Nixon sandbar for a swim. Longer charters head south past Key Biscayne to Stiltsville, the wooden houses on stilts in Biscayne National Park, or out into the ocean along Miami Beach.",
            "From November to April the bay is calm and the weather dry, and weekends book out early, especially around the holidays and Art Basel. In summer, go in the morning: afternoon storms are frequent, and captains move or shorten a charter when lightning is near. Most listings offer a new date or a refund when the weather cancels."
          ]
        }
      ],
      "faq": [
        {
          "q": "Do I need a licence to rent a yacht in Miami?",
          "a": "Not with a captain: every yacht on this page comes with a licensed captain who drives it. To drive a boat yourself in Florida, anyone born on or after 1 January 1988 needs a Boating Safety Education ID card or a temporary certificate, which rental companies can help you get."
        },
        {
          "q": "How many people can go on a yacht?",
          "a": "Most private yachts in Miami take up to 12 or 13 guests. For a larger group you need an inspected passenger yacht — a party boat licensed by the Coast Guard to carry more people — or two boats travelling together."
        },
        {
          "q": "How long should I rent a yacht for?",
          "a": "Four hours is the usual choice: enough for the skyline, Star Island and a stop at a sandbar. Many yachts have a three- or four-hour minimum; book six to eight hours to reach Stiltsville or spend a full day on the water."
        },
        {
          "q": "Should I tip the yacht captain?",
          "a": "Yes. The tip is rarely included in the charter price, and 15–20% of the charter is customary for the captain and crew, paid at the end of the trip."
        }
      ]
    },
    "sandbar-boat-tours": {
      "title": "Sandbar Boat Tours",
      "short": "Sandbar\nTours",
      "intro": "Boat trips to the Haulover and Nixon sandbars and Raccoon Island: swim and stand in the shallow, clear water of Biscayne Bay.",
      "seoTitle": "Miami Sandbar Boat Tours: Haulover & Nixon Sandbars",
      "heading": "Sandbar Boat Tours in Miami",
      "meta": "Boat tours to the Miami sandbars: Haulover sandbar and Raccoon Island in the north of Biscayne Bay, Nixon sandbar off Key Biscayne, private and guided trips.",
      "partnerTitle": "Your own boat to the sandbar",
      "partnerText": "Sailo lists private boats and yachts around Sunny Isles Beach, close to the Haulover sandbar. Choose a boat by size and guests, check with the owner that the sandbar is on the route, and book on its site.",
      "guideTitle": "Miami's sandbars: what to know",
      "guide": [
        {
          "h": "Haulover or Nixon?",
          "p": [
            "The Haulover sandbar lies just inside Haulover Inlet, in the north of Biscayne Bay between Bal Harbour and Sunny Isles Beach. It is the busiest of Miami's sandbars: boats anchor side by side in clear, waist-deep water, and at weekends it turns into a floating party with music and paddleboards. Raccoon Island, nearby, is quieter, with a short walk ashore and birds.",
            "The Nixon sandbar sits off Key Biscayne, near the bay side of the island, and is named after the president who had a house there. It is more spread out and often calmer than Haulover, with views back to the skyline. Trips there usually leave from the Miami River, Bayside or Key Biscayne."
          ]
        },
        {
          "h": "When to go",
          "p": [
            "The sandbars are at their best around low tide on a calm, sunny day, when the water is shallowest and clearest; at high tide it can reach your chest. Check the tide when you book a morning or afternoon trip, and ask the captain which they recommend.",
            "Weekdays are relaxed; Saturdays and Sundays are crowded and loud, and the Columbus Day regatta weekend in October is the biggest party on the bay. In summer, afternoon thunderstorms move in quickly, so morning trips are safer, and captains head back as soon as lightning is near."
          ]
        },
        {
          "h": "Getting there and the rules",
          "p": [
            "The sandbars can be reached only by boat. Without a boat of your own, join a guided sandbar trip, or charter a private boat with a captain for your group — from Haulover Park, Sunny Isles Beach or Miami Beach the Haulover sandbar is minutes away.",
            "On a captained boat, passengers may drink, but bring cans or plastic rather than glass, and take all rubbish back. Police and Florida wildlife officers patrol at weekends, including for illegal charters, so book with a licensed operator. Wear water shoes for the sand and seagrass, and reef-safe sunscreen."
          ]
        }
      ],
      "faq": [
        {
          "q": "Can you walk or swim to the Haulover sandbar?",
          "a": "No. The sandbar is in the bay off Haulover Inlet, with deep channels and boat traffic around it, so the only way there is by boat — a sandbar tour, a private boat with a captain or a boat of your own."
        },
        {
          "q": "How deep is the water at the sandbar?",
          "a": "Around low tide it is ankle- to waist-deep over most of the sandbar, so you can stand and walk. At high tide it gets deeper, and the edges drop off into channels, so children should wear life jackets."
        },
        {
          "q": "Can you drink alcohol at the Miami sandbars?",
          "a": "Passengers can drink on a boat with a captain; the person driving must not. Bring cans or plastic, as glass is banned on most boats, and expect police checks at the busy weekends."
        },
        {
          "q": "Which sandbar is better for families?",
          "a": "Go on a weekday morning to either one, or choose Nixon or Raccoon Island trips, which are quieter. Haulover at the weekend is a party, with loud music and crowds."
        }
      ]
    },
    "helicopter-tours": {
      "title": "Helicopter Tours",
      "short": "Helicopter\nTours",
      "intro": "Private helicopter and small-plane flights over Miami Beach, Biscayne Bay and the skyline, by day, at sunset or at night.",
      "seoTitle": "Miami Helicopter Tours & Scenic Flights",
      "heading": "Helicopter Tours in Miami",
      "meta": "Helicopter tours in Miami: private flights over Miami Beach, Star Island and the Downtown skyline, sunset and champagne flights, and scenic airplane tours.",
      "guideTitle": "How to choose a helicopter tour in Miami",
      "guide": [
        {
          "h": "Routes and how long",
          "p": [
            "Most flights follow the coast and the bay: up Miami Beach and Ocean Drive, over Star Island, Fisher Island and the cruise port, then around the towers of Downtown and Brickell. Longer routes continue north to the guitar-shaped Hard Rock hotel in Hollywood or out over the ocean. Flights last from about 20 minutes to an hour; the listing gives the time in the air, not counting the briefing.",
            "Sunset flights are the most popular, with the sky turning orange behind the skyline, and night flights show the city lit up. In the morning the air is usually clearer and calmer, which suits photography and anyone nervous about turbulence."
          ]
        },
        {
          "h": "Helicopter or small plane?",
          "p": [
            "A helicopter flies lower and slower, can turn and hover over the sights, and has large curved windows; most private helicopters take two or three passengers. A small plane covers a similar route faster and higher, usually for less, and many scenic planes have the wing above the cabin so it doesn't block the view.",
            "On a private flight the aircraft is only for your party, and the price is for the flight, not per person. Champagne after landing, photos and a set route are common extras — read what the listing includes."
          ]
        },
        {
          "h": "Before you fly",
          "p": [
            "Flights leave from small airports outside the centre, not from Miami Beach itself, so check the departure point and allow 30 to 45 minutes by car. Bring a photo ID; operators also ask for each passenger's weight when you book, as seats are assigned for balance and there are weight limits.",
            "Low cloud, storms and strong wind ground the flights, more often on summer afternoons; operators then offer another time or a refund. Wear dark clothing to cut reflections in the windows, and leave loose hats and bags in the car."
          ]
        }
      ],
      "faq": [
        {
          "q": "How much is a helicopter tour in Miami?",
          "a": "It depends on the length of the flight and whether it is private or shared: a private flight is priced for the whole aircraft, so it costs less per person with two or three passengers. The cards above show each operator's current price."
        },
        {
          "q": "How long is a Miami helicopter tour?",
          "a": "From about 20 minutes for a short beach-and-skyline loop to an hour for routes that reach Hollywood or fly out over the ocean. Plan on an hour more for the briefing and the drive to the airport."
        },
        {
          "q": "Is a helicopter tour worth it at sunset?",
          "a": "Sunset is the most booked time, for the colours over the skyline and Biscayne Bay. Book a few days ahead, as the sunset slots are few, and keep a little flexibility in case the weather moves the flight."
        },
        {
          "q": "Is there a weight limit on helicopter tours?",
          "a": "Yes. Operators ask for each passenger's weight when you book to balance the aircraft, and set a limit per seat; the exact limit is in the listing or on the operator's confirmation."
        }
      ]
    },
    "everglades": {
      "title": "Everglades & Airboats",
      "short": "Everglades\n& Airboats",
      "intro": "Airboat rides across the sawgrass, alligators and wildlife: tours into the Everglades, an hour from Miami.",
      "seoTitle": "Everglades Tours from Miami: Airboat Rides & Wildlife",
      "heading": "Everglades Airboat Tours from Miami",
      "meta": "Everglades tours from Miami: private and semi-private airboat rides, alligators and wildlife shows, half-day trips with hotel pickup and national park tours.",
      "guideTitle": "How to choose an Everglades tour",
      "guide": [
        {
          "h": "Airboat ride or a day in the park?",
          "p": [
            "Most Everglades tours are airboat rides: a flat boat pushed by a large fan skims across the sawgrass and the shallow water of the \"river of grass\", stopping to look for alligators, turtles and herons. A ride lasts from 30 to 90 minutes, and many parks on the Tamiami Trail add a wildlife show with alligators and snakes.",
            "Airboats are not allowed in most of Everglades National Park itself, so they run on its edges and in the conservation areas around it. To see the park, choose a tour that adds a guided walk, the tram at Shark Valley or an e-bike ride — these take a half day or a full day from Miami."
          ]
        },
        {
          "h": "Shared, semi-private or private",
          "p": [
            "Large shared airboats carry a few dozen passengers and are the cheapest option, often bundled with a bus from Miami. Semi-private and small-group rides put six to ten people on a smaller boat, which can slip into narrower channels. A private airboat is just for your party, with the captain stopping wherever there is something to see.",
            "If you are driving, book a ride at the airboat park: it is about 40 minutes to an hour from Downtown Miami. Without a car, choose a tour with pickup — the listing says whether transport is included and from where."
          ]
        },
        {
          "h": "When to go and what to expect",
          "p": [
            "The dry season, from December to April, is the best time for wildlife: animals gather around the remaining water and there are fewer mosquitoes. In summer the marsh is greener and fuller but hot, with afternoon storms, so take a morning ride. Alligators are seen all year.",
            "Airboats are loud — ear protection is handed out — and open to the sun, so bring a hat that won't blow away, sunscreen and insect repellent. Most rides suit children, but check the minimum age on the tour page."
          ]
        }
      ],
      "faq": [
        {
          "q": "How long is an Everglades airboat tour?",
          "a": "The ride itself lasts 30 to 90 minutes. With transport from Miami and a wildlife show, plan on four to six hours; tours that add the national park take a full day."
        },
        {
          "q": "Will I see alligators?",
          "a": "Very likely. Alligators live in the Everglades all year and the captains know where to look, especially in the dry season from December to April. Many parks also have an alligator show, so you see one up close either way."
        },
        {
          "q": "Is an Everglades tour suitable for children?",
          "a": "Yes, most airboat rides take children, and the wildlife shows are popular with them. Babies and toddlers may not be allowed on some boats because of the noise — check the minimum age on the tour page."
        },
        {
          "q": "Can I combine the Everglades with a Miami city tour?",
          "a": "Yes: combo tours add a Biscayne Bay cruise and a bus tour of Miami to the airboat ride in one day. They are a good deal if you have little time, but the stops are shorter than on separate tours."
        }
      ]
    },
    "city-tours": {
      "title": "City & Art Deco Tours",
      "short": "City &\nArt Deco",
      "intro": "South Beach's Art Deco district, Little Havana, Wynwood's murals and Coconut Grove — Miami on foot, by bike or by bus.",
      "seoTitle": "Miami City Tours: 3-in-1 Sightseeing, Walking & Golf Cart",
      "heading": "Miami City Tours & Sightseeing",
      "meta": "Miami city tours: 3-in-1 sightseeing of South Beach, Wynwood and Little Havana, private tours with a driver-guide, walking and golf cart tours, and an open-air bus.",
      "guideTitle": "How to choose a city tour in Miami",
      "guide": [
        {
          "h": "Three neighbourhoods in one tour",
          "p": [
            "Miami is spread out, so most visitors see it on a \"3-in-1\" tour: South Beach with its Art Deco hotels and Ocean Drive, the murals of Wynwood and Calle Ocho in Little Havana, by minibus or open-top bus in three to four hours. It is the cheapest way to get your bearings on the first day, with short stops for photos and a Cuban coffee.",
            "To see one area properly, choose a tour that sticks to it: a walking tour of the Art Deco district with an architecture guide, a golf cart, buggy or Segway ride through Wynwood's street art, or a food and culture walk in Little Havana."
          ]
        },
        {
          "h": "On foot, by golf cart or by bus",
          "p": [
            "Walking tours are the most detailed and usually last two to two and a half hours; the award-winning Art Deco tours add the neon of Ocean Drive at dusk. Golf carts and buggies cover Wynwood's blocks in an hour without the heat, and are a good choice with children or anyone who doesn't want to walk far. Open-top buses show more of the city — Brickell, Downtown, Coconut Grove — in one go.",
            "There are also tours of film and TV locations, a self-guided e-bike tour of Coral Gables and private tours with a driver-guide who adapts the route to you."
          ]
        },
        {
          "h": "Tips for the day",
          "p": [
            "Start early or late: Miami is hot and humid for most of the year, and midday is the hardest time to walk. Wear comfortable shoes and bring water and sunscreen. Evening tours of Wynwood and South Beach show the neon and the murals lit up.",
            "Check the meeting point — tours start in Miami Beach, Wynwood or Downtown, and only some include hotel pickup. The list is ranked by reviews, so the most consistently good tours come first."
          ]
        }
      ],
      "faq": [
        {
          "q": "What is the best city tour in Miami?",
          "a": "For a first visit, a 3-in-1 tour of South Beach, Wynwood and Little Havana covers the highlights in half a day. For depth, travelers rate the Art Deco walking tour of Miami Beach and the Wynwood golf-cart street-art tour highest."
        },
        {
          "q": "How long does a Miami city tour take?",
          "a": "Golf cart and Segway tours of Wynwood take one to one and a half hours, walking tours two to two and a half hours, and full city tours by bus three to four hours."
        },
        {
          "q": "Do city tours include hotel pickup?",
          "a": "Some do, especially the bus tours and private tours; walking and golf-cart tours usually meet at a point in the neighbourhood. The tour page says which."
        },
        {
          "q": "Are there city tours in Spanish?",
          "a": "Yes, many of Miami's guides speak Spanish and a number of city tours run in both languages. Each tour lists its languages on the partner's site."
        }
      ]
    },
    "day-trips": {
      "title": "Key West & Day Trips",
      "short": "Key West\n& Day Trips",
      "intro": "A day down the Overseas Highway to Key West, or out to the Everglades, Fort Lauderdale and the Florida Keys.",
      "seoTitle": "Day Trips from Miami: Key West, Kennedy Space Center",
      "heading": "Day Trips from Miami to Key West & Beyond",
      "meta": "Day trips from Miami: Key West via the Florida Keys and the Seven Mile Bridge, the Kennedy Space Center, Palm Beach and Fort Lauderdale, small-group or private.",
      "guideTitle": "How to choose a day trip from Miami",
      "guide": [
        {
          "h": "Key West and the Florida Keys",
          "p": [
            "The classic day trip runs down the Overseas Highway, which hops from island to island over the sea: Key Largo, Islamorada, the Seven Mile Bridge and finally Key West, about 160 miles from Miami. That is roughly four hours each way, so tours leave around 6–7 am and return late in the evening, with three to four hours on the island — the Southernmost Point, Duval Street, Hemingway's house and the sunset at Mallory Square on the longer tours.",
            "Small-group vans of up to about 14 people stop along the Keys for photos and breakfast; private tours with a driver let you choose the stops and the pace."
          ]
        },
        {
          "h": "North: the Space Center, Palm Beach and Fort Lauderdale",
          "p": [
            "The Kennedy Space Center at Cape Canaveral is about three and a half hours north, so the trip takes around 12 hours; the visitor complex has the Saturn V and Space Shuttle Atlantis, and you may see a launch if one is scheduled. Palm Beach, an hour and a half away, is a calmer day: the mansions of the island, the Flagler Museum and The Breakers hotel, often combined with Fort Lauderdale's canals and beach.",
            "For the Everglades, which are less than an hour away and take half a day, see the Everglades page."
          ]
        },
        {
          "h": "Small group or private?",
          "p": [
            "Small-group tours are the cheaper option and include the transport and a guide; entrance tickets, meals and activities in Key West or at the Space Center are often extra, so compare what is included. Private tours cost much more but are priced for the whole car or SUV, so they become reasonable for a family or a group of friends.",
            "Wear comfortable clothes for a long time in the car, bring snacks and a swimsuit if your tour stops at a beach, and check the pickup point and time the day before."
          ]
        }
      ],
      "faq": [
        {
          "q": "Is a day trip from Miami to Key West worth it?",
          "a": "If you can't stay overnight, yes — the drive over the Keys is part of the experience. But it is a long day of about 12 hours with eight in the car; with more time, spending a night in Key West is more relaxed."
        },
        {
          "q": "How far is Key West from Miami?",
          "a": "About 160 miles, or roughly four hours by road on the Overseas Highway without stops. Tours take longer because they stop in the Keys on the way."
        },
        {
          "q": "Can you visit the Kennedy Space Center from Miami in a day?",
          "a": "Yes, tours from Miami take about 12 hours: around three and a half hours each way and five to six hours at the visitor complex. Check whether the entrance ticket is included."
        },
        {
          "q": "What is included in a day trip?",
          "a": "Transport and a driver or guide are always included; entrance fees, meals and activities vary from tour to tour. Each tour page lists what is and isn't included."
        }
      ]
    },
    "water-sports": {
      "title": "Water Sports",
      "short": "Water\nSports",
      "intro": "Jet skis on Biscayne Bay, paddleboarding, snorkelling and parasailing off Miami Beach.",
      "seoTitle": "Water Sports in Miami: Jet Ski Tours, Banana Boats & More",
      "heading": "Water Sports in Miami",
      "meta": "Water sports in Miami: guided jet ski tours on Biscayne Bay, yachts with jet skis, banana boats and tubing, wakesurfing, waterskiing lessons and jet cars.",
      "guideTitle": "How to choose water sports in Miami",
      "guide": [
        {
          "h": "Jet ski tours on Biscayne Bay",
          "p": [
            "Jet skis are Miami's favourite water sport. On a guided tour you follow a guide across the bay for an hour or so, past the skyline, Star Island and the celebrity homes, with stops for photos; most tours put one or two riders on each jet ski. Rentals in a marked zone near the marina are shorter and cheaper, but you stay in one area.",
            "Florida law sets a minimum age for driving a jet ski, and anyone born on or after 1 January 1988 needs a boating safety certificate — the rental company issues a temporary one before you go out. Bring a photo ID, and expect a refundable deposit."
          ]
        },
        {
          "h": "Yachts with toys, banana boats and jet cars",
          "p": [
            "For a group, a yacht charter that comes with one or two jet skis, a banana boat or tubing combines a cruise with time on the water toys; some party boats include an open bar. There are also wakesurfing trips behind a specialised boat, waterskiing lessons for beginners and jet cars — small sports-car-shaped boats you drive yourself.",
            "Some tours pair a jet ski with an ATV ride or horseback riding on land for a half day of activities."
          ]
        },
        {
          "h": "Fees, weather and safety",
          "p": [
            "Check the total price before you book: fuel, the boat ride to the jet ski area, life jackets and taxes may be included or added on the day, and listings that say \"all fees included\" are easier to compare. Tips for the guide are customary.",
            "Mornings have the calmest water. Afternoon storms in summer can stop activities at short notice, and most operators then offer a new time or a refund. Wear a swimsuit, bring sunglasses with a strap and leave valuables on shore."
          ]
        }
      ],
      "faq": [
        {
          "q": "How much is a jet ski tour in Miami?",
          "a": "A guided one-hour jet ski tour costs roughly $85–190 per jet ski, depending on the operator and on what fees are included. Yacht charters with jet skis are priced for the whole group."
        },
        {
          "q": "Do I need a licence to drive a jet ski in Miami?",
          "a": "No licence, but anyone born on or after 1 January 1988 needs a Florida boating safety certificate; rental companies issue a temporary one on the spot after a short test. There is also a minimum age to drive — check it on the tour page."
        },
        {
          "q": "Can two people ride one jet ski?",
          "a": "Yes, most jet skis take two riders, and some tours charge per jet ski rather than per person, so riding together is cheaper."
        },
        {
          "q": "Are water sports suitable for children?",
          "a": "Children can usually ride as passengers with an adult, and banana boats and tubing are popular with older kids. Minimum ages differ by activity and operator — each tour page lists them."
        }
      ]
    },
    "attractions": {
      "title": "Attractions & Tickets",
      "short": "Attractions\n& Tickets",
      "intro": "Tickets for Miami's museums, gardens, zoos and parks — Vizcaya, the Frost Museum, Zoo Miami and more.",
      "seoTitle": "Miami Attractions Tickets: Museums, Zoo & Vizcaya",
      "heading": "Miami Attractions & Tickets",
      "meta": "Tickets for Miami attractions: Vizcaya, Superblue, PAMM, Frost Science, Zoo Miami, Jungle Island, the Paradox Museum, the Wynwood Walls and Go City passes.",
      "guideTitle": "How to choose attractions in Miami",
      "guide": [
        {
          "h": "Art, museums and gardens",
          "p": [
            "Miami's museums sit close together in a few areas. In Wynwood, the Wynwood Walls show murals by artists from around the world, with timed entry and guided tours, and the Museum of Graffiti covers the history of street art. Downtown, Pérez Art Museum Miami (PAMM) and the Frost Science museum with its aquarium and planetarium share Museum Park on the bay, a short walk from the Freedom Tower.",
            "Vizcaya, an Italian-style villa of the 1910s with formal gardens on the bay in Coconut Grove, is Miami's most elegant visit; the Deering Estate further south combines a historic house with nature trails. Superblue offers immersive light-and-sound art, and the Paradox and Ice Cream museums are playful, photo-friendly stops."
          ]
        },
        {
          "h": "Animals and family days",
          "p": [
            "Zoo Miami, in the south of the county, is a large open-air zoo where you need half a day, and a tram or bike helps in the heat. Jungle Island on Watson Island, between Downtown and Miami Beach, has birds, animal encounters and shows. For a whole family day, see the family page."
          ]
        },
        {
          "h": "Tickets and passes",
          "p": [
            "An online ticket saves queuing and, for the Wynwood Walls, Superblue and the Museum of Ice Cream, guarantees a time slot — at weekends and in the high season they sell out. A Go City pass bundles several attractions and tours for one price; it pays off if you plan to visit three or more on its list in a few days.",
            "Allow for travel between areas: Downtown to Vizcaya is about 15 minutes by car, to Zoo Miami 40 minutes. The list is ranked by reviews."
          ]
        }
      ],
      "faq": [
        {
          "q": "What are the must-see attractions in Miami?",
          "a": "Travelers' favourites are the Wynwood Walls, Vizcaya Museum and Gardens, PAMM and Frost Science in Museum Park, and the Art Deco district of South Beach, which you can see for free or with a guided tour."
        },
        {
          "q": "Do I need to book Wynwood Walls tickets in advance?",
          "a": "It is recommended: entry is by time slot, and weekend afternoons fill up. A ticket booked online lets you walk straight in at your time."
        },
        {
          "q": "Is the Go City Miami pass worth it?",
          "a": "It saves money if you visit at least three of the attractions and tours it includes within its validity. Make a plan first and compare it with the separate ticket prices."
        },
        {
          "q": "Which Miami attractions are indoors for a rainy day?",
          "a": "Frost Science, PAMM, Superblue, the Paradox Museum, the Museum of Ice Cream and the Museum of Graffiti are all indoors and good choices for a summer afternoon storm."
        }
      ]
    },
    "family": {
      "title": "Family Activities",
      "short": "Family\nwith Kids",
      "intro": "Things to do in Miami with kids: wildlife, gentle boat trips, aquariums and parks that suit every age.",
      "seoTitle": "Things to Do in Miami with Kids: Zoo, Science & More",
      "heading": "Family Activities in Miami",
      "meta": "Things to do in Miami with kids: Zoo Miami, Jungle Island, the Frost Science museum with its aquarium, the Museum of Ice Cream and family attraction passes.",
      "guideTitle": "Planning a family day in Miami",
      "guide": [
        {
          "h": "Animals and science",
          "p": [
            "Zoo Miami is the big day out: a large open-air zoo in the south of the county, with animals from Asia, Africa and the Americas in wide habitats. It takes four hours or more, so arrive at opening time to beat the heat. Jungle Island on Watson Island is smaller and closer to the beaches, with parrots, lemurs, animal encounters and shows.",
            "The Frost Science museum Downtown works for all ages and all weather: a three-level aquarium with sharks and rays, a planetarium, and hands-on exhibits on the human body and flight. The Museum of Ice Cream is a playful, sweet stop for younger children, with a sprinkle pool and plenty of tastings."
          ]
        },
        {
          "h": "Beyond tickets",
          "p": [
            "Many outings in other categories suit children too. An Everglades airboat ride with an alligator show is a favourite for school-age kids, a Biscayne Bay cruise is an easy hour on the water, and golf-cart tours of Wynwood show the murals without a long walk.",
            "If you plan several attractions, a Go City Explorer Pass lets you choose two to five of them for one price."
          ]
        },
        {
          "h": "Tips for families",
          "p": [
            "Plan outdoor visits for the morning and keep indoor ones for the afternoon, when the heat peaks and summer storms roll in. Children's tickets are usually cheaper and toddlers often free — check the age limits on each ticket page. Bring water, sunscreen and hats, and a stroller for the zoo."
          ]
        }
      ],
      "faq": [
        {
          "q": "What is there to do in Miami with toddlers?",
          "a": "Jungle Island, the aquarium at Frost Science and the Museum of Ice Cream are the easiest with small children: short visits, shade or air conditioning, and plenty to touch and see."
        },
        {
          "q": "How long do you need at Zoo Miami?",
          "a": "Plan four to six hours: the zoo is large and walking between the exhibits takes time. A tram or rented bikes make it easier with children."
        },
        {
          "q": "Is the Frost Science museum good for kids?",
          "a": "Yes — the aquarium, the planetarium and the interactive exhibits keep children of all ages busy for two to three hours, and it is a good plan for a rainy or very hot day."
        },
        {
          "q": "Are children's tickets cheaper?",
          "a": "Usually, yes, and young children are often free. The age limits differ between attractions and are listed on each ticket's page."
        }
      ]
    },
    "date-night": {
      "title": "Date Night",
      "intro": "Sunset cruises, dinners with a view and evenings out for two in Miami.",
      "seoTitle": "Romantic Things to Do in Miami: Sunset Cruises & Flights",
      "heading": "Date Night in Miami",
      "meta": "Romantic things to do in Miami: sunset and champagne cruises on Biscayne Bay, private yachts for two and sunset flights over Miami Beach.",
      "guideTitle": "Planning a romantic evening in Miami",
      "guide": [
        {
          "h": "Sunset on the water",
          "p": [
            "The simplest romantic plan in Miami is a sunset cruise: an hour or two on Biscayne Bay while the sky turns orange behind the Brickell towers, with a glass of champagne. Shared champagne cruises from Bayside are inexpensive and relaxed; a private boat for two, with a captain and a bottle on ice, is the more intimate version, and can stop at the quietest spot of the bay.",
            "Time it right: the sun sets around 5:30–6 pm in winter and after 8 pm in summer, and most tours schedule the sunset departure accordingly."
          ]
        },
        {
          "h": "Miami from above",
          "p": [
            "A private helicopter or small-plane flight over Miami Beach, the islands and the skyline is the date that is hard to forget. Flights last from 30 to 60 minutes, many include champagne after landing, and the sunset and night flights show the city lit up. Planes cost less than helicopters for a similar route.",
            "Flights take off from airports outside the centre, so allow travel time, and a weight limit per passenger usually applies. Routes and flight times: see Helicopter Tours."
          ]
        },
        {
          "h": "Tips for the evening",
          "p": [
            "Book a few days ahead for Fridays and Saturdays, and keep the end of the evening free for dinner in Brickell, Wynwood or South Beach. Summer storms can delay a sunset cruise or a flight; most tours offer another date or a refund."
          ]
        }
      ],
      "faq": [
        {
          "q": "What is the most romantic thing to do in Miami?",
          "a": "A private sunset cruise on Biscayne Bay with champagne, or a sunset helicopter flight over Miami Beach, are the experiences couples rate highest."
        },
        {
          "q": "How much is a sunset cruise for two in Miami?",
          "a": "A shared champagne cruise costs around $25–95 a person. A private boat for two with a captain starts at about $200–250 for two hours."
        },
        {
          "q": "When is sunset in Miami?",
          "a": "Around 5:30–6 pm in December and January and around 8:15 pm in June and July. Tours set their sunset departures by the season."
        },
        {
          "q": "Can I propose on a private boat or flight?",
          "a": "Yes, many captains and pilots are used to it: say so when you book, and ask about flowers, decorations or a photographer, which some tours offer as extras."
        }
      ]
    },
    "beach-days": {
      "title": "Beach Days",
      "intro": "Miami Beach, Key Biscayne and the best days on the sand and the water.",
      "seoTitle": "Beach Days in Miami: Best Beaches & Swim Stops",
      "heading": "Beach Days in Miami",
      "meta": "Plan a beach day in Miami: South Beach, Key Biscayne and Haulover beaches, island swims by boat, and tours that add Fort Lauderdale's beaches.",
      "guideTitle": "How to spend a beach day in Miami",
      "guide": [
        {
          "h": "Which beach for which day",
          "p": [
            "South Beach is the famous one: wide sand, lifeguard towers and Ocean Drive behind it, with cafés and showers a few steps away. For calmer, shallower water, head to Key Biscayne — Crandon Park, with shade and picnic areas, and Bill Baggs, with its lighthouse — or north to Haulover Park and Sunny Isles, which are quieter on weekdays.",
            "Some van tours pair Miami's beaches with Fort Lauderdale or Palm Beach for a day up the coast. If you would rather not drive, South Beach is the easiest to reach by bus or rideshare."
          ]
        },
        {
          "h": "A swim stop by boat",
          "p": [
            "The other way to spend a beach day is on the bay: a boat trip with a swim off a small island or at a sandbar, where the water is clear, warm and shallow. Raccoon Island tours add a short walk ashore with birds; private boats let your group stay as long as you like. The sandbars themselves — Haulover and Nixon, tides and weekends — have their own page: Sandbar Boat Tours."
          ]
        },
        {
          "h": "Sun, flags and seaweed",
          "p": [
            "The Florida sun is strong all year: bring reef-safe sunscreen, a hat and plenty of water, and look for shade in the middle of the day. On public beaches, swim near a lifeguard tower and check the flag colour for currents.",
            "From spring to late summer, sargassum seaweed sometimes washes up on the beaches; sandbar trips in the bay are usually less affected. Boat trips are rescheduled or refunded when storms cancel them."
          ]
        }
      ],
      "faq": [
        {
          "q": "Are Miami's beaches free?",
          "a": "Yes, the public beaches of Miami and Miami Beach are free. You pay for parking, and for chairs and umbrellas where they are rented; Crandon Park and Bill Baggs on Key Biscayne charge an entrance or parking fee per car."
        },
        {
          "q": "Which Miami beach is best for families?",
          "a": "Crandon Park on Key Biscayne has calm, shallow water, shade and facilities. South Beach is livelier, and Haulover Park and Sunny Isles in the north are quieter."
        },
        {
          "q": "Can you swim on a boat tour in Miami?",
          "a": "Yes, most private boats and sandbar or island tours include swimming stops. Shared sightseeing cruises from Bayside do not."
        },
        {
          "q": "When is the best time for a beach day in Miami?",
          "a": "The water is warm enough most of the year. From November to April the weather is dry and pleasant; summer is hotter, with afternoon storms, so go in the morning."
        }
      ]
    },
    "luxury": {
      "title": "Luxury Experiences",
      "intro": "Private yachts, seaplanes and exclusive tours — Miami at its most indulgent.",
      "seoTitle": "Luxury Experiences in Miami: Yachts, Flights & VIP Tours",
      "heading": "Luxury Experiences in Miami",
      "meta": "Luxury experiences in Miami: private yachts with a crew, champagne cruises, private scenic flights, exotic car rallies and VIP tours of the city.",
      "guideTitle": "Choosing a luxury experience in Miami",
      "guide": [
        {
          "h": "In the air",
          "p": [
            "Private helicopter and small-plane flights over Miami Beach, the islands of Biscayne Bay and the skyline are Miami's signature splurge, sunset and champagne flights most of all. Routes, flight times and what to check before you fly are on the Helicopter Tours page."
          ]
        },
        {
          "h": "On the water and on the road",
          "p": [
            "A private yacht with a crew is the classic way to spend a Miami afternoon in style: lunch and drinks on board, a swim at a sandbar and the celebrity homes of Star Island, with jet skis on the larger boats. Quieter alternatives include an electric boat on the Miami River with wine and charcuterie, or a champagne sunset cruise.",
            "On land, private full-day tours combine the city and a boat with a dedicated guide, a luxury van tour covers the beaches and neighbourhoods, and the exotic car rally drives supercars down to Key West and back over 24 hours."
          ]
        },
        {
          "h": "Before you book",
          "p": [
            "For yachts and flights, the price is for the private experience, not per person; check what is included — drinks, catering, the crew's gratuity, transfers — and the passenger limits, including weight limits on helicopters. Book a week or more ahead for weekends, Art Basel in December and the holidays."
          ]
        }
      ],
      "faq": [
        {
          "q": "What luxury experiences are there besides yachts and flights?",
          "a": "An exotic car rally that drives supercars to Key West and back over 24 hours, private full-day tours that combine the city and a boat with your own guide, a luxury van tour of the beaches and neighbourhoods, and an electric boat on the Miami River with wine and charcuterie."
        },
        {
          "q": "What is the most luxurious way to see Miami?",
          "a": "A private yacht charter on Biscayne Bay with a crew, followed by a sunset helicopter flight over Miami Beach, is the combination many visitors choose."
        },
        {
          "q": "Are drinks included on luxury cruises?",
          "a": "Champagne cruises include it in the price; on private yachts, it depends on the charter — some include an open bar, others let you bring your own. Check the tour page."
        },
        {
          "q": "Do I need to book luxury experiences in advance?",
          "a": "Yes, especially at weekends and in the high season from December to April: private yachts and helicopters have few slots and the best ones book up first."
        }
      ]
    },
    "art-and-culture": {
      "title": "Art & Culture",
      "intro": "Wynwood's street art, Art Deco architecture, Little Havana and Miami's museums.",
      "seoTitle": "Miami Art & Culture: Museums, Galleries & History Tours",
      "heading": "Art & Culture in Miami",
      "meta": "Art and culture in Miami: museums and galleries, the Design District, architecture and history tours, Cuban heritage and the city's street art.",
      "guideTitle": "Exploring Miami's art and culture",
      "guide": [
        {
          "h": "Street art and design",
          "p": [
            "Wynwood is the heart of Miami's art scene: former warehouses covered in murals around the Wynwood Walls, galleries, breweries and cafés. Tours go on foot, by golf cart or buggy, by Segway or with a street artist as your guide, and some combine the murals with food tastings or a spray-painting workshop. Next door, the Design District mixes luxury boutiques with public art and architecture, and Little River is the newer creative quarter.",
            "Art Basel Miami Beach in early December turns the whole city into an art fair, with dozens of satellite fairs and new murals — the busiest and most expensive week of the year."
          ]
        },
        {
          "h": "Art Deco and Cuban Miami",
          "p": [
            "South Beach has one of the largest collections of Art Deco buildings in the world: pastel hotels from the 1930s with neon signs, porthole windows and terrazzo floors. Guided walks explain the style and the preservation battle that saved it, and the Wolfsonian museum covers the design of the era.",
            "In Little Havana, Calle Ocho is the centre of Cuban Miami: a cigar factory where rollers work by hand, Domino Park, Cuban coffee from a street window and live music. Food and culture tours taste the classics, from the Cuban sandwich to guava pastries."
          ]
        },
        {
          "h": "Museums",
          "p": [
            "For art indoors, PAMM on the bay shows modern and contemporary art, Superblue has immersive installations, Vizcaya pairs a historic villa with its gardens, and the Freedom Tower tells the story of the Cuban exiles. Many tours here run in Spanish or French as well as English."
          ]
        }
      ],
      "faq": [
        {
          "q": "Is Wynwood free to visit?",
          "a": "The streets and most murals are free to walk around. The Wynwood Walls, the central garden of murals, requires a timed ticket; guided tours explain the artists and the neighbourhood."
        },
        {
          "q": "What is the best Art Deco tour in Miami Beach?",
          "a": "The award-winning Art Deco walking tours, including a neon evening version, are the most highly rated; private tours with an architecture guide go into more detail."
        },
        {
          "q": "What can you do in Little Havana?",
          "a": "Walk Calle Ocho, watch the domino players, visit a cigar factory, drink a Cuban coffee and try Cuban food; a tasting tour with a local guide covers it in two to three hours."
        },
        {
          "q": "When is Art Basel Miami Beach?",
          "a": "In early December each year. Hotels and tours book out and prices rise, so plan ahead if you visit then."
        }
      ]
    },
    "south-beach": {
      "title": "South Beach",
      "intro": "Ocean Drive, the Art Deco district and the beach — things to do in South Beach.",
      "seoTitle": "Things to Do in South Beach: Art Deco Tours & More",
      "heading": "Things to Do in South Beach, Miami Beach",
      "meta": "Things to do in South Beach: Art Deco walking tours of Ocean Drive, neon evening tours, Lincoln Road and Española Way, the Wolfsonian and boat trips from South Beach.",
      "guideTitle": "Exploring South Beach",
      "guide": [
        {
          "h": "The Art Deco district",
          "p": [
            "South Beach, the southern tip of Miami Beach, is built around its Art Deco district: hundreds of pastel hotels and apartment buildings from the 1920s to the 1940s along Ocean Drive, Collins Avenue and Washington Avenue, with racing stripes, porthole windows and neon. A guided walking tour, starting near the Art Deco Welcome Center on Ocean Drive, explains how the style grew and how the district was saved from demolition in the 1970s and 80s.",
            "Evening tours show the neon lit up, and some tours run in French or by bike; the Wolfsonian museum adds the decorative arts of the period."
          ]
        },
        {
          "h": "Beyond Ocean Drive",
          "p": [
            "Lincoln Road is the pedestrian street for shopping and cafés, and Española Way, with its Mediterranean revival arches, is lined with restaurants. The beach itself is wide and free, with the famous colourful lifeguard towers; South Pointe Park at the tip watches the cruise ships leave Government Cut.",
            "Several city tours combine South Beach with Wynwood and Little Havana in half a day, and some sailing trips leave from South Beach marinas."
          ]
        },
        {
          "h": "Tips",
          "p": [
            "Walk in the morning or late afternoon to avoid the midday heat, and go back to Ocean Drive after dark for the neon. Parking is expensive — rideshare or the free Miami Beach trolley are easier."
          ]
        }
      ],
      "faq": [
        {
          "q": "What is South Beach known for?",
          "a": "Its Art Deco architecture, the beach with its colourful lifeguard towers, the nightlife on Ocean Drive and Washington Avenue, and the shopping on Lincoln Road."
        },
        {
          "q": "How long is an Art Deco walking tour?",
          "a": "Usually two to two and a half hours, covering Ocean Drive and the streets behind it. Shorter highlights tours and private tours are also available."
        },
        {
          "q": "Is South Beach the same as Miami Beach?",
          "a": "South Beach is the southern part of Miami Beach, a separate city on a barrier island across Biscayne Bay from Miami. Most of the Art Deco district is there."
        },
        {
          "q": "Is South Beach walkable?",
          "a": "Yes, the Art Deco district, Lincoln Road and Española Way are all within a 20-minute walk of each other, and a free trolley runs through Miami Beach."
        }
      ]
    },
    "wynwood": {
      "title": "Wynwood",
      "intro": "Street art, galleries and breweries — things to do in Wynwood.",
      "seoTitle": "Things to Do in Wynwood: Street Art Tours & Wynwood Walls",
      "heading": "Things to Do in Wynwood, Miami",
      "meta": "Things to do in Wynwood: golf cart, buggy and Segway street-art tours, Wynwood Walls tickets, food and art tours, brewery tours and the Design District.",
      "guideTitle": "Exploring Wynwood",
      "guide": [
        {
          "h": "Murals and the Wynwood Walls",
          "p": [
            "Wynwood, a former warehouse district just north of Downtown, is one of the largest open-air street-art galleries in the world: hundreds of murals cover its walls, and new ones appear every year, especially around Art Basel in December. At its centre, the Wynwood Walls are a ticketed garden of murals by artists from around the world, with direct-entry tickets, early-access and after-hours visits and spray-painting workshops."
          ]
        },
        {
          "h": "How to tour it",
          "p": [
            "Golf carts and buggies are the most popular way to see Wynwood: an hour through the blocks with a guide who knows the artists, in the shade of the roof. Segway tours cover about four miles, and walking tours go slower and deeper, some led by a street artist or in French. After dark, the golf-cart night tour shows the murals lit up.",
            "Food and art tours add tastings in Wynwood's restaurants, and a brewery tour stops at its craft breweries. Next door, the Design District has public art, architecture and designer boutiques, and Little River is the creative quarter further north."
          ]
        },
        {
          "h": "Tips",
          "p": [
            "Visit in the morning or the evening rather than at midday, and wear comfortable shoes. Book the Wynwood Walls in advance for weekends."
          ]
        }
      ],
      "faq": [
        {
          "q": "How much time do you need in Wynwood?",
          "a": "A guided golf-cart tour takes about an hour; with the Wynwood Walls, a meal and a walk around, plan half a day."
        },
        {
          "q": "Do you need a ticket for Wynwood?",
          "a": "The neighbourhood is free to walk, but the Wynwood Walls require a ticket with a time slot."
        },
        {
          "q": "Is Wynwood safe to visit?",
          "a": "The central streets around the Wynwood Walls are busy day and evening and are fine to visit; as anywhere in a city, stay on the main streets at night and keep an eye on your things."
        },
        {
          "q": "What is the best way to see Wynwood's murals?",
          "a": "Travelers rate the small-group golf-cart tour highest: it covers the main murals in an hour with a guide who explains the artists, without walking in the heat."
        }
      ]
    },
    "little-havana": {
      "title": "Little Havana",
      "intro": "Calle Ocho, Cuban food, cigars and domino games — things to do in Little Havana.",
      "seoTitle": "Things to Do in Little Havana: Food & Cigar Tours",
      "heading": "Things to Do in Little Havana, Miami",
      "meta": "Things to do in Little Havana: Calle Ocho food and culture tours, a cigar factory tour, Cuban coffee and Domino Park, and city tours that include Little Havana.",
      "guideTitle": "Exploring Little Havana",
      "guide": [
        {
          "h": "Calle Ocho",
          "p": [
            "Little Havana, west of Downtown, grew from the Cuban exiles who arrived from the 1960s on, and Calle Ocho — SW 8th Street — is its main street. Along a few blocks you find Domino Park, where older men play dominoes under the trees, the Tower Theater, the Walk of Fame stars of Latin artists, fruit stands, art galleries and ventanitas, the street windows selling tiny cups of sweet Cuban coffee."
          ]
        },
        {
          "h": "Food, cigars and music",
          "p": [
            "A tasting tour is the best way in: two to three hours with a local guide, trying the Cuban sandwich, croquetas, empanadas, guava pastries and fresh juices, and hearing the history of the neighbourhood. A cigar factory tour shows how cigars are rolled by hand, and in the evening the bars of Calle Ocho play live Cuban music and salsa.",
            "On the last Friday of each month, Viernes Culturales turns Calle Ocho into a street festival with music and art."
          ]
        },
        {
          "h": "Combining it with other areas",
          "p": [
            "Little Havana is a regular stop on the half-day city tours that also cover South Beach and Wynwood, and some longer tours combine it with the Everglades. A dedicated food tour gives you far more time on Calle Ocho."
          ]
        }
      ],
      "faq": [
        {
          "q": "What is Little Havana famous for?",
          "a": "Cuban culture: Calle Ocho, Domino Park, hand-rolled cigars, Cuban coffee and food, and live Latin music."
        },
        {
          "q": "How long should I spend in Little Havana?",
          "a": "Two to three hours is enough for a walk along Calle Ocho with a coffee and a meal; a guided food tour fills that time well."
        },
        {
          "q": "Do you need to speak Spanish in Little Havana?",
          "a": "No, English is spoken in shops and restaurants, though Spanish is the language of the street — and the guides on many tours speak both."
        },
        {
          "q": "When is Viernes Culturales?",
          "a": "On the last Friday of every month, in the evening, along Calle Ocho, with live music, art and food stalls."
        }
      ]
    },
    "brickell": {
      "title": "Brickell & Downtown",
      "intro": "The skyline, Bayside and the bay — things to do in Brickell and Downtown Miami."
    },
    "seeAlso": "See also:",
    "faqTitle": "Frequently Asked Questions"
  },
  "partners": {
    "title": "Want more boats to choose from?",
    "text": "Sailo is a boat-rental marketplace with hundreds of private boats and yachts around Miami, from small motorboats to large yachts with a crew. Prices, availability and booking are on its site.",
    "button": "See boats"
  },
  "empty": {
    "title": "Coming soon",
    "text": "We are lining up the first partners for this list. Until then, here are a few ideas to start with."
  },
  "card": {
    "tour": "Tours & Experiences",
    "boat": "Yachts & Cruises",
    "from": "from {{price}}",
    "reviews_one": "{{count}} review",
    "reviews_other": "{{count}} reviews"
  },
  "footer": {
    "sisterSites": "Our other guides:",
    "about": "Tours, boat trips, Everglades airboats and things to do across Miami.",
    "thingsToDo": "Things to do",
    "areas": "Areas",
    "language": "Language",
    "disclosure": "© miami-todo.com · An independent guide. Some links are affiliate links: when you book through our partners we may earn a commission, at no extra cost to you.",
    "tours": "Tours & excursions"
  },
  "notFound": {
    "title": "Page not found",
    "text": "The page you were looking for doesn't exist or has moved.",
    "home": "Go to Miami To-Do"
  },
  "sample": {
    "dinner": {
      "category": "Date Night",
      "title": "Dinner with a View",
      "text": "Waterfront evenings with unforgettable views across Miami.",
      "place": "Brickell",
      "alt": "Waterfront terrace restaurant facing the Miami skyline at sunset"
    },
    "beach": {
      "category": "Beach Days",
      "title": "Miami Beach Days",
      "text": "Sun, sea and the lifeguard towers of South Beach.",
      "place": "Miami Beach",
      "alt": "Lifeguard tower on Miami Beach with the hotels behind it"
    },
    "yacht": {
      "category": "Yachts & Cruises",
      "title": "Private Yacht Experience",
      "text": "Sail along Miami’s coastline in total comfort.",
      "place": "Biscayne Bay",
      "alt": "Motor yacht cruising in front of the Miami skyline"
    }
  },
  "stub": {
    "saved": {
      "title": "Saved",
      "intro": "Keep the experiences you like in one place.",
      "text": "Saving experiences is coming soon. Until then, here are a few ideas to start with."
    },
    "account": {
      "title": "Account",
      "intro": "Your Miami To-Do account.",
      "text": "Accounts are coming soon. Until then, here are a few ideas to start with."
    }
  },
  "tours": {
    "searchLabel": "Search tours",
    "searchPlaceholder": "Airboat, sunset cruise, Key West…",
    "resultsFor": "Results for “{{query}}”",
    "noResults": "Nothing matches “{{query}}”.",
    "clearSearch": "Clear search",
    "showMore_one": "Show {{count}} more",
    "showMore_other": "Show {{count}} more"
  },
  "detail": {
    "book": "Book now",
    "via": "via {{partner}}",
    "delisted": "This experience is no longer available.",
    "duration": "Duration",
    "rating": "Rating",
    "price": "Price",
    "more": "More experiences"
  },
  "tourFacts": {
    "includedTitle": "What’s included",
    "included": "Included",
    "excluded": "Not included",
    "meetingTitle": "Meeting & pickup",
    "knowBeforeTitle": "Know before you go",
    "private": "Private tour — only your group takes part",
    "shared_one": "Shared tour, up to {{count}} traveler",
    "shared_other": "Shared tour, up to {{count}} travelers",
    "languages": "Guide languages: {{languages}}",
    "pickupOptions": {
      "PICKUP_EVERYONE": "Pickup included for all travelers",
      "PICKUP_AND_MEET_AT_START_POINT": "Pickup offered, or meet at the starting point",
      "MEET_EVERYONE_AT_START_POINT": "Meet at the starting point (no pickup)"
    }
  }
}
